/// <reference types="google-maps" />

import React from 'react';
import { Gis } from 'Douleutaras/components/Forms/gis.class';

import { GoogleLocationMap } from './GoogleLocationMap';

interface LocationMapProps {
  // Initial map center. When absent, the country's default center is used.
  center?: google.maps.LatLngLiteral;
  // When true, a newly provided `center` is reverse-geocoded and emitted through
  // `onChange` (used when the center comes from the device location).
  resolveCenter?: boolean;
  onChange(gis: Gis): void;
}

/**
 * Interactive location map backed by Google Maps. Kept as a thin wrapper so callers
 * depend on a stable `center`/`resolveCenter`/`onChange` contract.
 */
export const LocationMap = (props: LocationMapProps) => {
  return <GoogleLocationMap {...props} />;
};

export default LocationMap;
